// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Grouping & RCA page — sections 1–5 */

.nlp-grouping-inner {
  max-width: 1400px;
}

.nlp-filter-grid-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.nlp-filter-field-full {
  margin-bottom: 20px;
}

.nlp-question-input {
  width: 100%;
  padding: 12px 14px;
  border: 1px solid var(--border, #cbd5e1);
  border-radius: 10px;
  font-size: 0.875rem;
  font-family: inherit;
  color: var(--text, #1e293b);
  background: var(--surface, #fff);
  resize: vertical;
  min-height: 72px;
  line-height: 1.5;
  box-sizing: border-box;
}

.nlp-question-input:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
}

/* KPI stat cards — Section 1 */
.nlp-kpi-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  margin-top: 24px;
}

.nlp-kpi-card {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 20px 24px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 12px;
}

[data-theme="dark"] .nlp-kpi-card {
  background: rgba(37, 99, 235, 0.12);
  border-color: rgba(59, 130, 246, 0.35);
}

.nlp-kpi-value {
  font-size: 1.75rem;
  font-weight: 700;
  color: #2563eb;
  line-height: 1.2;
}

.nlp-kpi-label {
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--text-muted, #64748b);
}

/* Run grouping button — between section 1 and 2 */
.nlp-grouping-run-wrap {
  margin: 0;
}

.nlp-grouping-run-wrap .nlp-grouping-run-btn {
  width: 100%;
}

/* Section title with icon */
.nlp-section-title-icon {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Data tables — Sections 2 & 5 */
.nlp-table-wrap {
  overflow-x: auto;
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 10px;
}

.nlp-table-wrap-wide {
  max-height: 480px;
  overflow-y: auto;
}

.nlp-ticket-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px 20px;
  margin-bottom: 14px;
}

.nlp-ticket-filter {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 220px;
}

.nlp-ticket-filter select {
  padding: 8px 12px;
  border: 1px solid var(--border, #cbd5e1);
  border-radius: 8px;
  font-size: 0.875rem;
  font-family: inherit;
  color: var(--text, #1e293b);
  background: var(--surface, #fff);
}

.nlp-ticket-count {
  font-size: 0.8125rem;
  color: var(--text-muted, #64748b);
  white-space: nowrap;
}

.nlp-sortable-th {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.nlp-sortable-th:hover {
  background: var(--surface-hover, #f1f5f9);
}

.nlp-th-label {
  display: inline-flex;
  align-items: flex-start;
  justify-content: center;
  gap: 4px;
}

.nlp-sort-indicator {
  color: #2563eb;
  font-weight: 700;
  font-size: 0.75rem;
  line-height: 1;
}

.nlp-sort-indicator-idle {
  color: var(--text-muted, #94a3b8);
  font-weight: 500;
}

.nlp-grouping-empty-cell {
  text-align: center;
  color: var(--text-muted, #64748b);
  padding: 20px 14px !important;
}

.nlp-data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8125rem;
  background: var(--surface, #fff);
}

.nlp-data-table thead {
  position: sticky;
  top: 0;
  z-index: 1;
}

.nlp-data-table th {
  padding: 12px 10px;
  text-align: center;
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--text-muted, #64748b);
  background: var(--surface-2, #f8fafc);
  border-bottom: 1px solid var(--border, #e2e8f0);
  white-space: normal;
  word-break: normal;
  overflow-wrap: break-word;
}

/* Numeric columns: narrow width, allow 2-line header */
.nlp-th-num {
  max-width: 80px;
  min-width: 60px;
  text-align: center;
}

.nlp-data-table td {
  padding: 11px 10px;
  text-align: center;
  color: var(--text, #1e293b);
  border-bottom: 1px solid var(--divider, #f1f5f9);
  vertical-align: middle;
}

.nlp-data-table tbody tr:hover td {
  background: var(--surface-hover, #f8fafc);
}

.nlp-data-table tbody tr:last-child td {
  border-bottom: none;
}

.nlp-td-num {
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  text-align: center;
}

.nlp-td-mono {
  font-family: ui-monospace, 'SF Mono', Menlo, monospace;
  font-size: 0.8125rem;
}

.nlp-td-truncate {
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.nlp-table-wrap-wide .nlp-td-truncate {
  max-width: 180px;
}

/* Section 3 AI response */
.nlp-ai-response {
  margin-top: 20px;
  padding: 16px 18px;
  background: var(--surface-2, #f8fafc);
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 10px;
  border-left: 4px solid #2563eb;
}

.nlp-ai-response p {
  margin: 0;
  font-size: 0.875rem;
  line-height: 1.6;
  color: var(--text, #1e293b);
}

/* Section 4 export */
.nlp-export-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.nlp-grouping-error {
  margin-bottom: 16px;
  padding: 12px 16px;
  border-radius: 10px;
  border: 1px solid #fecaca;
  background: #fef2f2;
  color: #b91c1c;
  font-size: 0.875rem;
  line-height: 1.5;
}

.nlp-grouping-error-inline {
  margin-top: 16px;
  margin-bottom: 0;
}

[data-theme="dark"] .nlp-grouping-error {
  background: rgba(239, 68, 68, 0.12);
  border-color: rgba(248, 113, 113, 0.4);
  color: #fca5a5;
}

.nlp-grouping-empty {
  margin: 0;
  padding: 8px 0;
  color: var(--text-muted, #64748b);
  font-size: 0.875rem;
}

@media (max-width: 768px) {
  .nlp-kpi-grid {
    grid-template-columns: 1fr;
  }

  .nlp-filter-grid-2 {
    grid-template-columns: 1fr;
  }

  .nlp-td-truncate {
    max-width: 120px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/kedb/grouping/grouping.css"],"names":[],"mappings":"AAAA,uCAAuC;;AAEvC;EACE,iBAAiB;AACnB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,2BAA2B;EAC3B,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA,kDAAkD;AAClD;EACE,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,8BAA8B;EAC9B,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,wCAAwC;EACxC,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iCAAiC;EACjC,qCAAqC;EACrC,+CAA+C;EAC/C,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,uDAAuD;AACvD;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sDAAsD;EACtD,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,wCAAwC;EACxC,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,qBAAqB;AACrB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* Grouping & RCA page — sections 1–5 */\n\n.nlp-grouping-inner {\n  max-width: 1400px;\n}\n\n.nlp-filter-grid-2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.nlp-filter-field-full {\n  margin-bottom: 20px;\n}\n\n.nlp-question-input {\n  width: 100%;\n  padding: 12px 14px;\n  border: 1px solid var(--border, #cbd5e1);\n  border-radius: 10px;\n  font-size: 0.875rem;\n  font-family: inherit;\n  color: var(--text, #1e293b);\n  background: var(--surface, #fff);\n  resize: vertical;\n  min-height: 72px;\n  line-height: 1.5;\n  box-sizing: border-box;\n}\n\n.nlp-question-input:focus {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);\n}\n\n/* KPI stat cards — Section 1 */\n.nlp-kpi-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px;\n  margin-top: 24px;\n}\n\n.nlp-kpi-card {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 20px 24px;\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 12px;\n}\n\n[data-theme=\"dark\"] .nlp-kpi-card {\n  background: rgba(37, 99, 235, 0.12);\n  border-color: rgba(59, 130, 246, 0.35);\n}\n\n.nlp-kpi-value {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: #2563eb;\n  line-height: 1.2;\n}\n\n.nlp-kpi-label {\n  font-size: 0.6875rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--text-muted, #64748b);\n}\n\n/* Run grouping button — between section 1 and 2 */\n.nlp-grouping-run-wrap {\n  margin: 0;\n}\n\n.nlp-grouping-run-wrap .nlp-grouping-run-btn {\n  width: 100%;\n}\n\n/* Section title with icon */\n.nlp-section-title-icon {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Data tables — Sections 2 & 5 */\n.nlp-table-wrap {\n  overflow-x: auto;\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 10px;\n}\n\n.nlp-table-wrap-wide {\n  max-height: 480px;\n  overflow-y: auto;\n}\n\n.nlp-ticket-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 12px 20px;\n  margin-bottom: 14px;\n}\n\n.nlp-ticket-filter {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 220px;\n}\n\n.nlp-ticket-filter select {\n  padding: 8px 12px;\n  border: 1px solid var(--border, #cbd5e1);\n  border-radius: 8px;\n  font-size: 0.875rem;\n  font-family: inherit;\n  color: var(--text, #1e293b);\n  background: var(--surface, #fff);\n}\n\n.nlp-ticket-count {\n  font-size: 0.8125rem;\n  color: var(--text-muted, #64748b);\n  white-space: nowrap;\n}\n\n.nlp-sortable-th {\n  cursor: pointer;\n  user-select: none;\n}\n\n.nlp-sortable-th:hover {\n  background: var(--surface-hover, #f1f5f9);\n}\n\n.nlp-th-label {\n  display: inline-flex;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 4px;\n}\n\n.nlp-sort-indicator {\n  color: #2563eb;\n  font-weight: 700;\n  font-size: 0.75rem;\n  line-height: 1;\n}\n\n.nlp-sort-indicator-idle {\n  color: var(--text-muted, #94a3b8);\n  font-weight: 500;\n}\n\n.nlp-grouping-empty-cell {\n  text-align: center;\n  color: var(--text-muted, #64748b);\n  padding: 20px 14px !important;\n}\n\n.nlp-data-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.8125rem;\n  background: var(--surface, #fff);\n}\n\n.nlp-data-table thead {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.nlp-data-table th {\n  padding: 12px 10px;\n  text-align: center;\n  font-size: 0.6875rem;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: var(--text-muted, #64748b);\n  background: var(--surface-2, #f8fafc);\n  border-bottom: 1px solid var(--border, #e2e8f0);\n  white-space: normal;\n  word-break: normal;\n  overflow-wrap: break-word;\n}\n\n/* Numeric columns: narrow width, allow 2-line header */\n.nlp-th-num {\n  max-width: 80px;\n  min-width: 60px;\n  text-align: center;\n}\n\n.nlp-data-table td {\n  padding: 11px 10px;\n  text-align: center;\n  color: var(--text, #1e293b);\n  border-bottom: 1px solid var(--divider, #f1f5f9);\n  vertical-align: middle;\n}\n\n.nlp-data-table tbody tr:hover td {\n  background: var(--surface-hover, #f8fafc);\n}\n\n.nlp-data-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.nlp-td-num {\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n  text-align: center;\n}\n\n.nlp-td-mono {\n  font-family: ui-monospace, 'SF Mono', Menlo, monospace;\n  font-size: 0.8125rem;\n}\n\n.nlp-td-truncate {\n  max-width: 220px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.nlp-table-wrap-wide .nlp-td-truncate {\n  max-width: 180px;\n}\n\n/* Section 3 AI response */\n.nlp-ai-response {\n  margin-top: 20px;\n  padding: 16px 18px;\n  background: var(--surface-2, #f8fafc);\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 10px;\n  border-left: 4px solid #2563eb;\n}\n\n.nlp-ai-response p {\n  margin: 0;\n  font-size: 0.875rem;\n  line-height: 1.6;\n  color: var(--text, #1e293b);\n}\n\n/* Section 4 export */\n.nlp-export-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.nlp-grouping-error {\n  margin-bottom: 16px;\n  padding: 12px 16px;\n  border-radius: 10px;\n  border: 1px solid #fecaca;\n  background: #fef2f2;\n  color: #b91c1c;\n  font-size: 0.875rem;\n  line-height: 1.5;\n}\n\n.nlp-grouping-error-inline {\n  margin-top: 16px;\n  margin-bottom: 0;\n}\n\n[data-theme=\"dark\"] .nlp-grouping-error {\n  background: rgba(239, 68, 68, 0.12);\n  border-color: rgba(248, 113, 113, 0.4);\n  color: #fca5a5;\n}\n\n.nlp-grouping-empty {\n  margin: 0;\n  padding: 8px 0;\n  color: var(--text-muted, #64748b);\n  font-size: 0.875rem;\n}\n\n@media (max-width: 768px) {\n  .nlp-kpi-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .nlp-filter-grid-2 {\n    grid-template-columns: 1fr;\n  }\n\n  .nlp-td-truncate {\n    max-width: 120px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
